<template>
	<div v-if="error">
		<h2>Something went wrong, please try again.</h2>
	</div>
	<div v-else>
		<slot v-bind="payload" />
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import query from '@/lib/query'

export default {
	name: 'strapi-list',
	props: {
		source: String,
		route: String,
		query: {
			type: Object,
			default: () => {}
		},
		watchUrl: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			loading: false,
			error: false,
			count: 0,
			results: []
		}
	},
	computed: {
		payload() {
			return {
				loading: this.loading,
				items: this.results,
				count: this.count,
				refresh: this.refresh
			}
		}
	},
	methods: {
		...mapActions('api', ['get']),
		async refresh(options = {}) {
			this.$emit('refresh', options)

			// Get query
			let q = { ...this.query }
			if (this.watchUrl) q = { ...q, ...this.$route.query }
			const qs = query.roll({ query: q })

			// Reset loading & error states
			this.loading = true
			this.error = false

			// Clear current results page
			this.results = []

			// Recount and refetch using new params
			try {
				const endpoint = this.source + qs
				const data = await this.get({ endpoint }).then(res => res.json())
				this.count = data.count
				this.results = data.results
				this.$emit('update', data)
			} catch (err) {
				this.error = true
			}

			this.loading = false
		}
	},
	watch: {
		loading(next) {
			this.$emit('loading', next)
		},
		$route(to) {
			if (this.watchUrl && (!this.route || to.name === this.route)) {
				this.refresh()
			}
		}
	},
	async created() {
		this.refresh()
	}
}
</script>

<style lang="scss" scoped></style>
